// extracted by mini-css-extract-plugin
export default {"label":"styles_label__WU64-","error":"styles_error__mJR4T","checkbox":"styles_checkbox__jEAKf"};